export const ACTION_LOAD_SITE_GOOGLE_ANALYTICS__REQUEST = 'ACTION_LOAD_SITE_GOOGLE_ANALYTICS__REQUEST';
export const ACTION_LOAD_SITE_GOOGLE_ANALYTICS__SUCCESS = 'ACTION_LOAD_SITE_GOOGLE_ANALYTICS__SUCCESS';
export const ACTION_LOAD_SITE_GOOGLE_ANALYTICS__FAIL = 'ACTION_LOAD_SITE_GOOGLE_ANALYTICS__FAIL';

export const ACTION_EDIT_SITE_GOOGLE_ANALYTICS__REQUEST = 'ACTION_EDIT_SITE_GOOGLE_ANALYTICS__REQUEST';
export const ACTION_EDIT_SITE_GOOGLE_ANALYTICS__SUCCESS = 'ACTION_EDIT_SITE_GOOGLE_ANALYTICS__SUCCESS';
export const ACTION_EDIT_SITE_GOOGLE_ANALYTICS__FAIL = 'ACTION_EDIT_SITE_GOOGLE_ANALYTICS__FAIL';
